<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_ATTH_GRP_BSC_INFO') }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-module-submodule-select
              ref="smComboFrame0"
              :pageId="pageId"
              :selectedMd="frame0.selectData.COD_MDLE"
              :selectedSmd="frame0.selectData.COD_SMDLE"
              :disabled="true"
              class="dp_flex"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_ATTH_GRP_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ frame0.attachGroupId }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_ATTH_GRP_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <sui-text-field
              v-model="frame0.attachGroupName"
              :disabled="true"
              :readonly="false"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_EXPL')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <textarea
              v-model="frame0.attachGroupContent"
              :disabled="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RGST_USR')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <cmp-user-name-link
              :pageId="pageId"
              :displayType="'1'"
              :displayLanguageId="frame0.displayLanguageIdRegistration"
              :knoxId="frame0.knoxIdRegistration"
              :userName="frame0.userNameRegistration"
              :userGlobalName="frame0.userGlobalNameRegistration"
              :departmentName="frame0.departmentNameRegistration"
              :departmentEnglishName="frame0.departmentEnglishNameRegistration"
              :type="'link'"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RGST_DTM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ frame0.firstRegistrationDTM }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDFC_USR')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <cmp-user-name-link
              :pageId="pageId"
              :displayType="'1'"
              :displayLanguageId="frame0.displayLanguageIdModification"
              :knoxId="frame0.knoxIdModification"
              :userName="frame0.userNameModification"
              :userGlobalName="frame0.userGlobalNameModification"
              :departmentName="frame0.departmentNameModification"
              :departmentEnglishName="frame0.departmentEnglishNameModification"
              :type="'link'"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDFC_DTM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ frame0.finalModificationDTM }}
            </div>
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_HDQT_MGT_ITEM') }}</h4>
      </div>
      <sui-grid
        ref="grid"
        :hideHeader="true"
        :initial-pagesize="3"
        :pagesizeoptions="[3]"
        :dataset="'dsEssentialYes'"
        :columns="gridColumns0"
        :columnsautoresize="true"
        :autowidth="true"
        :columnsresize="true"
      />
      <div class="mrB30" />
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_ATTH_ITEM_SELT_LIST') }}</h4>
      </div>
      <sui-grid
        ref="grid0"
        :hideHeader="true"
        :initial-pagesize="3"
        :pagesizeoptions="[3]"
        :dataset="'dsEssentialNo'"
        :columns="gridColumns1"
        :columnsautoresize="true"
        width="100%"
        :autowidth="true"
        :autoheight="true"
        :columnsresize="true"
      />
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClickCancel"
      >
        {{ $t('MSG_BTN_CANCEL') }}
      </sui-button>
      <sui-button
        v-permission:update="pageId"
        type="button"
        class="comm_btn_solid"
        @click="onClickSave"
      >
        {{ $t('MSG_BTN_SAVE') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

const gridEditor = utils.getGridCellFactory();

export default {
  name: 'PGE_CMD_00006_P02', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    selectedGridRowData: {
      type: Object,
      default: null,
    },
    siteId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      codes: {
        ynOption: [{ key: 'Y', label: 'Yes' },
          { key: 'N', label: 'No' }],
        COD_ATTH_PSBL_EXTS: [{ key: 'ALL', label: this.$t('MSG_TXT_ALL') },
          { key: 'IMG', label: this.$t('MSG_TXT_IMG') },
          { key: 'PDF', label: 'PDF' }],
      },
      frame0: {
        selectData: {
          COD_MDLE: {
            label: '',
            key: '',
          },
          COD_SMDLE: {
            label: '',
            key: '',
          },
          COD_ATTH_ITEM_MGT_YN: {
            label: '',
            key: '',
          },
          COD_IMG_PRVW_APPY_YN: {
            label: '',
            key: '',
          },
          COD_DLOAD_HIS_MGT_YN: {
            label: '',
            key: '',
          },
          COD_DLOAD_RSN_INP_YN: {
            label: '',
            key: '',
          },
        },
        attachGroupId: '',
        attachGroupName: '',
        attachGroupContent: '',
        finalModificationUserId: '',
        finalModificationDTM: '',
        firstRegistrationUserId: '',
        firstRegistrationDTM: '',
        attachRestrictionSize: '',
        knoxIdModification: '',
        userNameModification: '',
        userGlobalNameModification: '',
        departmentNameModification: '',
        departmentEnglishNameModification: '',
        knoxIdRegistration: '',
        userNameRegistration: '',
        userGlobalNameRegistration: '',
        departmentNameRegistration: '',
        departmentEnglishNameRegistration: '',
        displayLanguageIdRegistration: '',
        displayLanguageIdModification: '',
      },
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_ITEM_NM'),
        datafield: 'attachItemName',
      }, {
        text: this.$t('MSG_TXT_HDQT_NCSR_YN'),
        datafield: 'headquarterEssentialYn',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_EXTS'),
        datafield: 'attachPossibilityExtensionCode',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_ATTH_EXLD_PSBL_YN'),
        datafield: 'attachExcludePossibilityYn',
        width: '120px',
      }, {
        text: this.$t('MSG_TXT_STDD_FORM'),
        datafield: 'standardButton',
        width: '80px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onClickStandardForm,
            type: 'link',
          }, this.dsEssentialYes, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }],
      localdata1: [],
      gridColumns1: [{
        text: this.$t('MSG_TXT_ITEM_NM'),
        datafield: 'attachItemName',
      }, {
        text: this.$t('MSG_TXT_USE_YN'),
        datafield: 'attachItemUseYn',
        width: '80px',
        createwidget: (row, column, value, htmlElement) => {
          gridEditor.createCellSegmentBox(row, column, value, htmlElement, {
          }, this.dsEssentialNo, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          gridEditor.refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_NCSR_YN'),
        datafield: 'headquarterEssentialYn',
        width: '80px',
        createwidget: (row, column, value, htmlElement) => {
          gridEditor.createCellSegmentBox(row, column, value, htmlElement, {
          }, this.dsEssentialNo, this.$refs.grid0);
        },
        initwidget(row, column, value, htmlElement) {
          gridEditor.refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_EXTS'),
        datafield: 'attachPossibilityExtensionCode',
        width: '100px',
        createwidget: (row, column, value, htmlElement) => {
          gridEditor.createCellSelect(row, column, value, htmlElement, {
            optionList: this.codes.COD_ATTH_PSBL_EXTS,
          }, this.dsEssentialNo, this.$refs.grid0);
        },
        initwidget(row, column, value, htmlElement) {
          gridEditor.refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_ATTH_EXLD_PSBL_YN'),
        datafield: 'attachExcludePossibilityYn',
        width: '120px',
        createwidget: (row, column, value, htmlElement) => {
          gridEditor.createCellSegmentBox(row, column, value, htmlElement, {
          }, this.dsEssentialNo, this.$refs.grid0);
        },
        initwidget(row, column, value, htmlElement) {
          gridEditor.refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_STDD_FORM'),
        datafield: 'standardFormName',
        width: 300,
        createwidget: (row, column, value, htmlElement) => {
          const componentInstance = gridEditor.createCellTextFieldWithButton(row, column, value, htmlElement, {
            textFieldProps: {
              readonly: true,
              disabled: true,
            },
            buttonProps: {
              name: this.$t('MSG_BTN_SELT'),
              disabled: false,
            },
            handler: (e, rowData, boundindex, cloumnName) => {
              const rowIndex = boundindex;

              utils.openLayerPopup('PGE_CMD_00005', data => {
                // 콜백
                if (!utils.isEmpty(data)) {
                  componentInstance.dataset.setData(rowIndex, 'standardFormName', data[0].documentName);
                  componentInstance.dataset.setData(rowIndex, 'standardFormId', data[0].documentId);
                }
              }, {
                pageInitialData: {},
                size: 'md',
              });
            },
          }, this.dsEssentialNo, this.$refs.grid0);
          // const instance = componentInstance.getComponentInstance();

          // instance.$on('clickButton', () => {
          //   const rowIndex = componentInstance.getDatasetIndex();

          //   utils.openLayerPopup('PGE_CMD_00005', data => {
          //     // 콜백
          //     if (!utils.isEmpty(data)) {
          //       componentInstance.dataset.setData(rowIndex, 'standardFormName', data[0].documentName);
          //       componentInstance.dataset.setData(rowIndex, 'standardFormId', data[0].documentId);
          //     }
          //   }, {
          //     pageInitialData: {},
          //     size: 'md',
          //   });
          // });
        },
        initwidget(row, column, value, htmlElement) {
          gridEditor.refreshCell(row, column, value, htmlElement);
        },
      }],
    };
  },
  watch: {
    selectedGridRowData(obj) {
      if (obj) {
        this.selectDataFormInput(obj);
      }
    },
  },
  datasets: [{
    id: 'dsEssentialYes',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'standardButton', map: 'standardButton' },
      { type: 'string', name: 'attachItemName', map: 'attachItemName' },
      { type: 'string', name: 'headquarterEssentialYn', map: 'headquarterEssentialYn' },
      { type: 'string', name: 'attachPossibilityExtensionCode', map: 'attachPossibilityExtensionCode' },
      { type: 'string', name: 'standardFormId', map: 'standardFormId' },
      { type: 'string', name: 'attachExcludePossibilityYn', map: 'attachExcludePossibilityYn' }],
  }, {
    id: 'dsEssentialNo',
    type: 'local',
    data: 'localdata1',
    datafields: [
      { type: 'string', name: 'attachItemId', map: 'attachItemId' },
      { type: 'string', name: 'attachItemName', map: 'attachItemName' },
      { type: 'string', name: 'attachItemUseYn', map: 'attachItemUseYn' },
      { type: 'string', name: 'headquarterEssentialYn', map: 'headquarterEssentialYn' },
      { type: 'string', name: 'attachPossibilityExtensionCode', map: 'attachPossibilityExtensionCode' },
      { type: 'string', name: 'siteEssentialTypeCode', map: 'siteEssentialTypeCode' },
      { type: 'string', name: 'attachExcludePossibilityYn', map: 'attachExcludePossibilityYn' },
      { type: 'string', name: 'standardFormName', map: 'standardFormName' },
      { type: 'string', name: 'standardFormId', map: 'standardFormId' },
      { type: 'string', name: 'arrayalOrder', map: 'arrayalOrder' },
      { type: 'string', name: 'attachItemContent', map: 'attachItemContent' },
      { type: 'string', name: 'rowType', map: 'rowType' }],
  }],
  mounted() {
    this.$nextTick(() => {
      this.selectDataFormInput(this.selectedGridRowData);
    });
  },
  methods: {
    /**
     * 첨부그룹 정보 SET
     */
    selectDataFormInput(obj) {
      // 기본정보
      utils.forEach(this.frame0, (value, key) => {
        if (utils.isEqual(key, 'selectData')) {
          this.frame0[key].COD_MDLE.key = obj.moduleCode;
          this.frame0[key].COD_SMDLE.key = obj.subModuleCode;
          this.frame0[key].COD_ATTH_ITEM_MGT_YN.key = obj.attachItemManagementYn;
          this.frame0[key].COD_IMG_PRVW_APPY_YN.key = obj.imagePreviewApplyYn;
          this.frame0[key].COD_DLOAD_HIS_MGT_YN.key = obj.downloadHistoryManagementYn;
          this.frame0[key].COD_DLOAD_RSN_INP_YN.key = obj.downloadReasonInputYn;
        } else {
          this.frame0[key] = obj[key];
        }
      });

      // 첨부항목
      http.request(this.pageId, 'DTS_CMD_00015', {
        path: {
          'attach-group-id': obj.attachGroupId,
        },
        query: {
          siteId: this.siteId,
        },
      }).then(res => {
        // 첨부항목(제어여부 Y) 표준양식 조회 버튼명 설정
        utils.forEach(res.data.yes, (itm, index) => {
          res.data.yes[index].standardButton = this.$t('MSG_BTN_SRCH');
        });
        // 첨부항목(제어여부 Y/N) 구분하여 data Set
        this.dsEssentialYes.setRawData(res.data.yes); // 데이터 셋에 데이터를 넣는 함수
        this.dsEssentialNo.setRawData(res.data.no); // 데이터 셋에 데이터를 넣는 함수
      });
    },
    /**
     * 닫기
     */
    onClickCancel() {
      this.$emit('onClickClose');
    },
    /**
     * 저장
     */
    onClickSave() {
      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.pageId, 'DTS_CMD_00016', {
          path: {
            'attach-group-id': this.frame0.attachGroupId,
            'site-id': this.siteId,
          },
          data: this.dsEssentialNo.data,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'), null, () => {
            this.$emit('onRowReSelect');
            this.onClickCancel();
          });
        });
      });
    },
    /**
     * 표준양식 조회 공통팝업
     */
    onClickStandardForm(event, dataRow) {
      utils.openLayerPopup('PGE_CMD_00008', () => {}, {
        pageInitialData: {
          standardFormId: dataRow.standardFormId,
        },
        size: 'md',
      });
    },
  },
};
</script>

  <style scoped>
  </style>
